module.exports = __webpack_public_path__ + "img/1440.84030ec1.jpg";